import { General } from './General'
import { Statistics } from './Statistics'

export const Component = {  General, Statistics }
